<template>
  <div class="contact-form crt-container" :class="{ open: $store.state.contact }">
    <div
      class="contact-form__header"
      @click="$store.commit('SET_CONTACT', false)"
      @mouseenter="$store.commit('SET_POINTER', 'pointer')"
      @mouseleave="$store.commit('SET_POINTER', 'default')"
    >
      <div class="contact-form__back">
        <img src="/static/vector/arrow.svg" alt="Back Home">
        <span></span>
      </div>
      <div class="contact-form__label">BACK</div>
    </div>

    <form action="" ref="form">
      <div class="form__row-label">
        <span>NAME</span>
      </div>
      <div class="form__row-input" ref="name">
        <input type="text" name="name" id="name" autocomplete="off">
      </div>

      <div class="form__row-label">
        <span>EMAIL</span>
      </div>
      <div class="form__row-input" ref="email">
        <input type="email" name="email" id="email" autocomplete="off">
      </div>

      <div class="form__row-label">
        <span>PHONE</span>
      </div>
      <div class="form__row-input">
        <input type="tel" name="tel" id="tel" autocomplete="off">
      </div>

      <div class="form__row-label">
        <span>MESSAGE</span>
      </div>
      <div class="form__row-input">
        <textarea rows="1"></textarea>
      </div>

      <div class="form__row-placeholder">
        <div class="form__row-label">MESSAGE</div>
      </div>
      <div class="form__row-container">
        <div
          class="form__row-privacy"
          ref="privacy"
          @mouseenter="$store.commit('SET_POINTER', 'pointer')"
          @mouseleave="$store.commit('SET_POINTER', 'default')"
        >
          <input type="checkbox" id="privacy" name="privacy" />
          <label for="privacy">Accept <a target="_blank" href="https://www.iubenda.com/privacy-policy/13526818/cookie-policy">Privacy</a></label>
        </div>
        <div
          class="form__row-send"
          @click="sendForm"
          @mouseenter="$store.commit('SET_POINTER', 'pointer')"
          @mouseleave="$store.commit('SET_POINTER', 'default')"
        >
          <span>SEND</span>
        </div>
      </div>
    </form>

    <div class="form__overlay form__overlay--sending" v-if="state === 'sending'">
      <span>SENDING</span>
    </div>
    <div class="form__overlay form__overlay--sended" v-if="state === 'sended'">
      <span>SENT</span>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ContactForm',

  data() {
    return {
      state: '',
    };
  },

  methods: {
    sendForm() {
      const errors = [...this.$el.querySelectorAll('.error')];
      errors.forEach(e => e.classList.remove('error'));
      const formData = new FormData(this.$refs.form);
      let valid = true;
      if (formData.get('name').length < 1) {
        this.$refs.name.classList.add('error');
        valid = false;
      }
      if (formData.get('privacy') !== 'on') {
        this.$refs.privacy.classList.add('error');
        valid = false;
      }
      if (formData.get('email').indexOf('@') < 2 || formData.get('email').indexOf('.') < 2) {
        this.$refs.email.classList.add('error');
        valid = false;
      }
      if (valid) {
        this.state = 'sending';
        const data = {};
        formData.forEach((value, key) => { data[key] = value; });

        axios('https://us-central1-diesel-wynwood.cloudfunctions.net/api/sendMail', {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
          },
          data: JSON.stringify(data),
        }).then((response) => {
          if (response.status) {
            this.state = 'sended';
            setTimeout(() => { this.state = ''; }, 4000);
          } else {
            this.state = 'error';
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-form {
  @extend %full-fixed;
  color: $color-white;
  padding: calc((100vh / 18) * 1) calc((100vw / 32) * 1);
  padding-top: calc((100vh / 18) * 3);

  transform: translateY(100%);
  transition: transform .6s $inOutCubic;

  z-index: 13;

  @include mq($until: ipadP) {
    padding: calc((100vh / 18) * 1) calc((100vw / 32) * 2);
    padding-top: calc((100vh / 18) * 3);
  }

  &__header {
    position: absolute;
    top: 0px;
    padding: calc((100vh / 18) * 1) calc((100vw / 32) * 1);
    padding-top: calc((100vh / 18) * 1.5);
    left: 0px;
    width: fit-content;
    font-family: 'VHS';

    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  &__back {
    display: flex;

    img {
      transform: scaleX(-1);
      margin-right: 30px;
    }
  }

  form {
    position: relative;
    height: 100%;
    width: 100%;
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    grid-template-rows: repeat(5, 1fr);

    @include mq($until: ipadP) {
      display: block;
    }
  }

  &.open {
    transform: translateY(0%);
  }

  .form__row {
    &-label {
      padding-right: 40px;
    }

    &-label span,
    &-input input,
    &-input textarea {
      width: 100%;
      font-size: rem(120px);
      font-size: calc(120px * var(--rw));
      line-height: rem(120px);
      line-height: calc(120px * var(--rw));
      padding: 0px;
      border-radius: 0px;

      @include mq($until: ipadP) {
        font-size: rem(50px);
        font-size: calc(50px * var(--rw));
        line-height: rem(50px);
        line-height: calc(50px * var(--rw));
        margin-bottom: 10px;
      }
    }

    &-input {
      @include mq($until: ipadP) {
        margin-bottom: 20px;
      }
    }

    &-input textarea {
      padding-bottom: calc(10px * var(--rw));
    }

    &-input input,
    &-input textarea {
      background-color: transparent;
      border: none;
      border-bottom: 1px solid $color-white;

      &:focus {
        outline: none;
      }
    }

    &-container {
      flex-grow: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &-placeholder {
      opacity: 0;
    }

    &-send {
      font-family: 'VHS';
      position: relative;
      font-size: rem(70px);
      font-size: calc(70px * var(--rw));
      line-height: rem(70px);
      line-height: calc(70px * var(--rw));

      &::after {
        content: ' ';
        position: absolute;
        left: 0px;
        bottom: -4px;
        width: 100%;
        height: 1px;
        background-color: $color-white;
      }
    }

    &-privacy {
      position: relative;
      left: 10px;

      label {
        position: relative;
        left: 40px;

        a {
          text-decoration: underline;
        }

        @include mq($until: ipadP) {
          left: 20px;
          bottom: 5px;
        }
      }

      input[type="checkbox"] {
        position: relative;
        cursor: none;

        &::after {
          content: ' ';
          position: absolute;
          width: 20px;
          height: 20px;
          transform: translateX(-2.5px) translateY(-2.5px);
          border-radius: 100%;
          background-color: $color-white;
          display: none;

          @include mq($until: ipadP) {
            transform: translateX(-50%) translateY(-50%);
          }
        }

        &::before {
          content: ' ';
          position: absolute;
          top: -20px;
          left: -20px;
          width: calc(70px * var(--rw));
          height: calc(70px * var(--rw));
          border: 1px solid white;
          background-color: #00f;
        }

        &:checked::before {
          background-color: $color-white;
        }
      }
    }
  }

  .form__overlay {
    @extend %full;
    background-color: rgba($color: $color-dark, $alpha: 0.8);

    display: flex;
    align-items: center;
    justify-content: center;

    font-family: 'VHS';
    font-size: rem(200px);
    font-size: calc(200px * var(--rw));
    line-height: rem(200px);
    line-height: calc(200px * var(--rw));
    color: $color-white;
  }

  .error input {
    border-color: rgb(196, 25, 25);

    &::after,
    &::before {
      border-color: rgb(196, 25, 25) !important;
    }
  }
}
</style>

<style lang="scss" scoped>
.crt-container {
  background-color: #00f;
}

@keyframes flicker {
  0% {
    opacity: 0.27861;
  }
  5% {
    opacity: 0.34769;
  }
  10% {
    opacity: 0.23604;
  }
  15% {
    opacity: 0.90626;
  }
  20% {
    opacity: 0.18128;
  }
  25% {
    opacity: 0.83891;
  }
  30% {
    opacity: 0.65583;
  }
  35% {
    opacity: 0.67807;
  }
  40% {
    opacity: 0.26559;
  }
  45% {
    opacity: 0.84693;
  }
  50% {
    opacity: 0.96019;
  }
  55% {
    opacity: 0.08594;
  }
  60% {
    opacity: 0.20313;
  }
  65% {
    opacity: 0.71988;
  }
  70% {
    opacity: 0.53455;
  }
  75% {
    opacity: 0.37288;
  }
  80% {
    opacity: 0.71428;
  }
  85% {
    opacity: 0.70419;
  }
  90% {
    opacity: 0.7003;
  }
  95% {
    opacity: 0.36108;
  }
  100% {
    opacity: 0.24387;
  }
}
@keyframes textShadow {
  0% {
    text-shadow: 0.4389924193300864px 0 1px rgba(0,30,255,0.5), -0.4389924193300864px 0 1px rgba(255,0,80,0.3), 0 0 3px;
  }
  5% {
    text-shadow: 2.7928974010788217px 0 1px rgba(0,30,255,0.5), -2.7928974010788217px 0 1px rgba(255,0,80,0.3), 0 0 3px;
  }
  10% {
    text-shadow: 0.02956275843481219px 0 1px rgba(0,30,255,0.5), -0.02956275843481219px 0 1px rgba(255,0,80,0.3), 0 0 3px;
  }
  15% {
    text-shadow: 0.40218538552878136px 0 1px rgba(0,30,255,0.5), -0.40218538552878136px 0 1px rgba(255,0,80,0.3), 0 0 3px;
  }
  20% {
    text-shadow: 3.4794037899852017px 0 1px rgba(0,30,255,0.5), -3.4794037899852017px 0 1px rgba(255,0,80,0.3), 0 0 3px;
  }
  25% {
    text-shadow: 1.6125630401149584px 0 1px rgba(0,30,255,0.5), -1.6125630401149584px 0 1px rgba(255,0,80,0.3), 0 0 3px;
  }
  30% {
    text-shadow: 0.7015590085143956px 0 1px rgba(0,30,255,0.5), -0.7015590085143956px 0 1px rgba(255,0,80,0.3), 0 0 3px;
  }
  35% {
    text-shadow: 3.896914047650351px 0 1px rgba(0,30,255,0.5), -3.896914047650351px 0 1px rgba(255,0,80,0.3), 0 0 3px;
  }
  40% {
    text-shadow: 3.870905614848819px 0 1px rgba(0,30,255,0.5), -3.870905614848819px 0 1px rgba(255,0,80,0.3), 0 0 3px;
  }
  45% {
    text-shadow: 2.231056963361899px 0 1px rgba(0,30,255,0.5), -2.231056963361899px 0 1px rgba(255,0,80,0.3), 0 0 3px;
  }
  50% {
    text-shadow: 0.08084290417898504px 0 1px rgba(0,30,255,0.5), -0.08084290417898504px 0 1px rgba(255,0,80,0.3), 0 0 3px;
  }
  55% {
    text-shadow: 2.3758461067427543px 0 1px rgba(0,30,255,0.5), -2.3758461067427543px 0 1px rgba(255,0,80,0.3), 0 0 3px;
  }
  60% {
    text-shadow: 2.202193051050636px 0 1px rgba(0,30,255,0.5), -2.202193051050636px 0 1px rgba(255,0,80,0.3), 0 0 3px;
  }
  65% {
    text-shadow: 2.8638780614874975px 0 1px rgba(0,30,255,0.5), -2.8638780614874975px 0 1px rgba(255,0,80,0.3), 0 0 3px;
  }
  70% {
    text-shadow: 0.48874025155497314px 0 1px rgba(0,30,255,0.5), -0.48874025155497314px 0 1px rgba(255,0,80,0.3), 0 0 3px;
  }
  75% {
    text-shadow: 1.8948491305757957px 0 1px rgba(0,30,255,0.5), -1.8948491305757957px 0 1px rgba(255,0,80,0.3), 0 0 3px;
  }
  80% {
    text-shadow: 0.0833037308038857px 0 1px rgba(0,30,255,0.5), -0.0833037308038857px 0 1px rgba(255,0,80,0.3), 0 0 3px;
  }
  85% {
    text-shadow: 0.09769827255241735px 0 1px rgba(0,30,255,0.5), -0.09769827255241735px 0 1px rgba(255,0,80,0.3), 0 0 3px;
  }
  90% {
    text-shadow: 3.443339761481782px 0 1px rgba(0,30,255,0.5), -3.443339761481782px 0 1px rgba(255,0,80,0.3), 0 0 3px;
  }
  95% {
    text-shadow: 2.1841838852799786px 0 1px rgba(0,30,255,0.5), -2.1841838852799786px 0 1px rgba(255,0,80,0.3), 0 0 3px;
  }
  100% {
    text-shadow: 2.6208764473832513px 0 1px rgba(0,30,255,0.5), -2.6208764473832513px 0 1px rgba(255,0,80,0.3), 0 0 3px;
  }
}

.crt-container::after {
  content: " ";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(18, 16, 16, 0.1);
  opacity: 0;
  z-index: 2;
  pointer-events: none;
  animation: flicker 0.15s infinite;
}

.crt-container::before {
  content: " ";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: linear-gradient(rgba(18, 16, 16, 0) 50%, rgba(0, 0, 0, 0.25) 50%), linear-gradient(90deg, rgba(255, 0, 0, 0.06), rgba(0, 255, 0, 0.02), rgba(0, 0, 255, 0.06));
  z-index: 2;
  background-size: 100% 2px, 3px 100%;
  pointer-events: none;
}

.crt-container {
  animation: textShadow 1.6s infinite;
}

.site-title {
  font-size: 2rem;
}
</style>
